// This file is auto-generated by @hey-api/openapi-ts

import { queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { deleteApiPermissionsByGraphFolderIdRemove, getApiGraphFolders, getApiGraphUsers, getApiLicenseCheck, getApiLicenseCurrent, getApiLicenseVersion, getApiPermissionsByGraphFolderId, type Options, postApiPermissionsApplyAll, postApiPermissionsApplySelected, postApiPermissionsByGraphFolderIdAdd, putApiPermissionsByGraphFolderIdUpdate } from '../sdk.gen';
import type { DeleteApiPermissionsByGraphFolderIdRemoveData, DeleteApiPermissionsByGraphFolderIdRemoveError, DeleteApiPermissionsByGraphFolderIdRemoveResponse, GetApiGraphFoldersData, GetApiGraphFoldersError, GetApiGraphFoldersResponse, GetApiGraphUsersData, GetApiGraphUsersError, GetApiGraphUsersResponse, GetApiLicenseCheckData, GetApiLicenseCheckError, GetApiLicenseCheckResponse, GetApiLicenseCurrentData, GetApiLicenseCurrentError, GetApiLicenseCurrentResponse, GetApiLicenseVersionData, GetApiLicenseVersionError, GetApiLicenseVersionResponse, GetApiPermissionsByGraphFolderIdData, GetApiPermissionsByGraphFolderIdError, GetApiPermissionsByGraphFolderIdResponse, PostApiPermissionsApplyAllData, PostApiPermissionsApplyAllError, PostApiPermissionsApplyAllResponse, PostApiPermissionsApplySelectedData, PostApiPermissionsApplySelectedError, PostApiPermissionsApplySelectedResponse, PostApiPermissionsByGraphFolderIdAddData, PostApiPermissionsByGraphFolderIdAddError, PostApiPermissionsByGraphFolderIdAddResponse, PutApiPermissionsByGraphFolderIdUpdateData, PutApiPermissionsByGraphFolderIdUpdateError, PutApiPermissionsByGraphFolderIdUpdateResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getApiGraphFoldersQueryKey = (options?: Options<GetApiGraphFoldersData>) => createQueryKey('getApiGraphFolders', options);

export const getApiGraphFoldersOptions = (options?: Options<GetApiGraphFoldersData>) => queryOptions<GetApiGraphFoldersResponse, GetApiGraphFoldersError, GetApiGraphFoldersResponse, ReturnType<typeof getApiGraphFoldersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiGraphFolders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiGraphFoldersQueryKey(options)
});

export const getApiGraphUsersQueryKey = (options?: Options<GetApiGraphUsersData>) => createQueryKey('getApiGraphUsers', options);

export const getApiGraphUsersOptions = (options?: Options<GetApiGraphUsersData>) => queryOptions<GetApiGraphUsersResponse, GetApiGraphUsersError, GetApiGraphUsersResponse, ReturnType<typeof getApiGraphUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiGraphUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiGraphUsersQueryKey(options)
});

export const getApiLicenseCheckQueryKey = (options?: Options<GetApiLicenseCheckData>) => createQueryKey('getApiLicenseCheck', options);

export const getApiLicenseCheckOptions = (options?: Options<GetApiLicenseCheckData>) => queryOptions<GetApiLicenseCheckResponse, GetApiLicenseCheckError, GetApiLicenseCheckResponse, ReturnType<typeof getApiLicenseCheckQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiLicenseCheck({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLicenseCheckQueryKey(options)
});

export const getApiLicenseCurrentQueryKey = (options?: Options<GetApiLicenseCurrentData>) => createQueryKey('getApiLicenseCurrent', options);

export const getApiLicenseCurrentOptions = (options?: Options<GetApiLicenseCurrentData>) => queryOptions<GetApiLicenseCurrentResponse, GetApiLicenseCurrentError, GetApiLicenseCurrentResponse, ReturnType<typeof getApiLicenseCurrentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiLicenseCurrent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLicenseCurrentQueryKey(options)
});

export const getApiLicenseVersionQueryKey = (options?: Options<GetApiLicenseVersionData>) => createQueryKey('getApiLicenseVersion', options);

export const getApiLicenseVersionOptions = (options?: Options<GetApiLicenseVersionData>) => queryOptions<GetApiLicenseVersionResponse, GetApiLicenseVersionError, GetApiLicenseVersionResponse, ReturnType<typeof getApiLicenseVersionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiLicenseVersion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLicenseVersionQueryKey(options)
});

export const getApiPermissionsByGraphFolderIdQueryKey = (options: Options<GetApiPermissionsByGraphFolderIdData>) => createQueryKey('getApiPermissionsByGraphFolderId', options);

export const getApiPermissionsByGraphFolderIdOptions = (options: Options<GetApiPermissionsByGraphFolderIdData>) => queryOptions<GetApiPermissionsByGraphFolderIdResponse, GetApiPermissionsByGraphFolderIdError, GetApiPermissionsByGraphFolderIdResponse, ReturnType<typeof getApiPermissionsByGraphFolderIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiPermissionsByGraphFolderId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPermissionsByGraphFolderIdQueryKey(options)
});

export const postApiPermissionsApplyAllMutation = (options?: Partial<Options<PostApiPermissionsApplyAllData>>): UseMutationOptions<PostApiPermissionsApplyAllResponse, PostApiPermissionsApplyAllError, Options<PostApiPermissionsApplyAllData>> => {
    const mutationOptions: UseMutationOptions<PostApiPermissionsApplyAllResponse, PostApiPermissionsApplyAllError, Options<PostApiPermissionsApplyAllData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiPermissionsApplyAll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiPermissionsApplySelectedMutation = (options?: Partial<Options<PostApiPermissionsApplySelectedData>>): UseMutationOptions<PostApiPermissionsApplySelectedResponse, PostApiPermissionsApplySelectedError, Options<PostApiPermissionsApplySelectedData>> => {
    const mutationOptions: UseMutationOptions<PostApiPermissionsApplySelectedResponse, PostApiPermissionsApplySelectedError, Options<PostApiPermissionsApplySelectedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiPermissionsApplySelected({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postApiPermissionsByGraphFolderIdAddMutation = (options?: Partial<Options<PostApiPermissionsByGraphFolderIdAddData>>): UseMutationOptions<PostApiPermissionsByGraphFolderIdAddResponse, PostApiPermissionsByGraphFolderIdAddError, Options<PostApiPermissionsByGraphFolderIdAddData>> => {
    const mutationOptions: UseMutationOptions<PostApiPermissionsByGraphFolderIdAddResponse, PostApiPermissionsByGraphFolderIdAddError, Options<PostApiPermissionsByGraphFolderIdAddData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiPermissionsByGraphFolderIdAdd({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteApiPermissionsByGraphFolderIdRemoveMutation = (options?: Partial<Options<DeleteApiPermissionsByGraphFolderIdRemoveData>>): UseMutationOptions<DeleteApiPermissionsByGraphFolderIdRemoveResponse, DeleteApiPermissionsByGraphFolderIdRemoveError, Options<DeleteApiPermissionsByGraphFolderIdRemoveData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiPermissionsByGraphFolderIdRemoveResponse, DeleteApiPermissionsByGraphFolderIdRemoveError, Options<DeleteApiPermissionsByGraphFolderIdRemoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiPermissionsByGraphFolderIdRemove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putApiPermissionsByGraphFolderIdUpdateMutation = (options?: Partial<Options<PutApiPermissionsByGraphFolderIdUpdateData>>): UseMutationOptions<PutApiPermissionsByGraphFolderIdUpdateResponse, PutApiPermissionsByGraphFolderIdUpdateError, Options<PutApiPermissionsByGraphFolderIdUpdateData>> => {
    const mutationOptions: UseMutationOptions<PutApiPermissionsByGraphFolderIdUpdateResponse, PutApiPermissionsByGraphFolderIdUpdateError, Options<PutApiPermissionsByGraphFolderIdUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putApiPermissionsByGraphFolderIdUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
